<template>
  <section>

    <el-form ref="loginForm" :model="form" :rules="rules" label-width="80px" class="login-box">
      <h3 class="login-title">欢迎登录</h3>
      <el-form-item label="账号" prop="username">
        <el-input type="text" placeholder="请输入账号" v-model="form.username"></el-input>
      </el-form-item>
      <el-form-item label="密码" prop="password">
        <el-input type="password" placeholder="请输入密码" v-model="form.password"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" v-on:click="f_Submit()">登录</el-button>
      </el-form-item>

    </el-form>
    <icp-footer></icp-footer>
  </section>
</template>

<script>
  import * as Api from '../api/api'
  import IcpFooter from "./footer.vue";

  export default {
    components: {IcpFooter},
    data() {
      return {
        form: {username: "", password: ""},
        rules: {
          username: [
            {required: true, message: '账号不可为空', trigger: 'blur'}
          ],
          password: [
            {required: true, message: '密码不可为空', trigger: 'blur'}
          ]
        }
      }
    },
    mounted() {
    },
    methods: {
      f_Submit() {
        this.$refs.loginForm.validate((valid) => {
          if (valid) {
            Api.Login(this.form.username, this.form.password).then(res => {
              if (res.code === 1) {
                sessionStorage.setItem("user", JSON.stringify(res.data));
                this.$router.push("/");
              } else {
                this.$message.error(`登录失败:${res.error}`);
              }
            });
          }
        });
      }
    }
  }
</script>

<style scoped>
  .login-box {
    border: 1px solid #DCDFE6;
    width: 350px;
    margin: 180px auto;
    padding: 35px 35px 15px 35px;
    border-radius: 5px;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    box-shadow: 0 0 25px #909399;
  }

  .login-title {
    text-align: center;
    margin: 0 auto 40px auto;
    color: #303133;
  }
</style>



// WEBPACK FOOTER //
// src/components/Login.vue